import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import ApiRequestor from '../../api_access/ApiRequestor';
import { IonButton, IonCard, IonCardTitle, IonCol, IonContent, IonGrid, IonIcon, IonInput, IonItem, IonLabel, IonRow, IonText } from '@ionic/react';
import { checkmarkCircleOutline, closeCircleOutline, helpCircleOutline } from 'ionicons/icons';

import { GetABMUsers } from '../../store/ABMUsers/ABMUsersActions';
import { ClientMaintenanceDefaultStateI } from '../../store/mainInfo/clientMaintenanceReducer';

import './ABMUsers.css';
import Modal from '../Modal/Modal';

interface Props extends StateTypes, dispatchTypes {
    client?: any;
    backToTable: () => void;
}

const AddABMUsers: React.FC<Props> = (props): JSX.Element => {

    const regularExpressionEmail = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const regularExpressionPass = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;
    const regularExpressionPhone = /^\+549\d{10}$/;
    const regularExpressionUsername = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ_]+([a-zA-ZáéíóúÁÉÍÓÚñÑ]+)*$/;
    const nameRegex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ]+(\s[a-zA-ZáéíóúÁÉÍÓÚñÑ]+)*$/;
    const [showModal, setShowModal] = useState(false);
    const [textModal, setTextModal] = useState('')
    const [dataForm, saveDataForm] = useState({
        username: '',
        password: '',
        passwordRep: '',
        first_name: '',
        last_name: '',
        phone_number: '',
        category: '',
        email: '',
        emailRep: ''
    });
    const [categoryClient, setCategoryClient] = useState('')
    const { username, password, passwordRep, first_name, last_name, phone_number, category, email, emailRep } = dataForm;
    const [errors, setErrors] = useState({ first_name: '', last_name: '', username:'',email: '', emailRep:'', password:'', passwordRep:'', phone_number:'' });

    useEffect(() => {
        if (sessionStorage.getItem('clientUsers') !== "CONSULTA") {
            if (props.clientMaintenance.loading === false && props.clientMaintenance.clientMaintenance) {
                const filterClient = props.clientMaintenance.clientMaintenance.filter((client: any) => client.service_name === props.client)
                const category = filterClient[0].service_category
                setCategoryClient(category)
            }
        } else if(sessionStorage.getItem('clientUsers') === "CONSULTA"){
            setCategoryClient("ADMIN")
        }
    }, [props.clientMaintenance.loading, props.clientMaintenance.clientMaintenance])

    const getDataForm = (e: any) => {
        saveDataForm({
            ...dataForm,
            [e.target.name]: e.detail.value!
        })
    }


    const validationForm = () => {
        const isEmpty = (value: any) => !value.trim();
        const isInvalidText = (value: any) => !nameRegex.test(value);
        const isInvalidUserName = (value: any) => !regularExpressionUsername.test(value);
        
        const errors = {
            first_name: isEmpty(dataForm.first_name)
                ? 'El campo "Nombre" no debe ser vacío'
                : isInvalidText(dataForm.first_name) || dataForm.last_name.length >= 30
                ? 'Solo letras y espacios intermedios. Máximo 30 carácteres'
                : '',
            last_name: isEmpty(dataForm.last_name)
                ? 'El campo "Apellido" no debe ser vacío'
                : isInvalidText(dataForm.last_name) || dataForm.last_name.length >= 30
                ? 'Solo letras y espacios intermedios. Máximo 30 carácteres'
                : '',
            username: isEmpty(dataForm.username) 
                ? 'El campo "Usuario" no debe ser vacío'
                : isInvalidUserName(dataForm.username) || dataForm.last_name.length >= 30
                ? 'No acepta espacios intermedios. Máximo 30 carácteres'
                : '',
            email: !regularExpressionEmail.test(dataForm.email) || dataForm.email.length >= 80
                ? 'El campo "Email" debe ser válido. Máximo 80 carácteres'
                : '',
            emailRep: !regularExpressionEmail.test(dataForm.emailRep) || dataForm.email.length >= 80
                ? 'El campo "Email" debe ser válido. Máximo 80 carácteres'
                : dataForm.email !== dataForm.emailRep
                ? 'Los email no coinciden'
                : '',
            password: !regularExpressionPass.test(dataForm.password) || dataForm.password.length >= 24
                ? 'Entre 8 y 24 caracteres, al menos 1 mayúscula, 1 minúsculas, 1 número y 1 carácter especial (#?!@$%^&*-)'
                : '',
            passwordRep: dataForm.password !== dataForm.passwordRep
                ? 'Las contraseñas no coinciden'
                : '',
            phone_number: !regularExpressionPhone.test(dataForm.phone_number) || dataForm.phone_number.length >= 25
                ? 'Debe ser de la forma +549 más 10 dígitos'
                : ''
        };
    
        setErrors(errors as any);
        const hasErrors = Object.values(errors).some(error => error !== '');

        return hasErrors;
    }

    const createNewUser = async (e: any) => {
        e.preventDefault();
        
        validationForm();

        let valid = validationForm();

        if (!valid) {
            let data: any = {
                body: {
                    username: dataForm.username,
                    password: dataForm.password,
                    bank_id: props.client,
                    first_name: dataForm.first_name,
                    last_name: dataForm.last_name,
                    phone_number: dataForm.phone_number,
                    email: dataForm.email,
                    category: categoryClient,
                }
            }

            const response: any = await ApiRequestor.requestToApi("/user", "POST", data, "USER");

            if (response && response.status === 200) {
                setTextModal('Usuario Creado Correctamente')
                props.getABMUsers()
                setShowModal(true);
            } else {
                if (response && response.includes("status code 500")) {
                    setTextModal('No se pudo crear el usuario. Por favor chequear los datos ingresados')
                    setShowModal(true)
                }
            }
        } else {
            validationForm()
        }
    }

    const dismissModal = () => {
        setShowModal(false);
        if (textModal.includes('Usuario Creado Correctamente')) {
            props.backToTable()
        }
    }

    const onKeyPressLetters = (e: any) => {
        const re = /[A-ZÑñ ]+/g;
        if (re.test(e.key)) {
            e.preventDefault();
        }
    }

    return (
        <div className="custom-content-scroll ion-padding">
            <IonCard className="ABMUsersFormCard">
                <IonCardTitle className="ion-text-center ABMUsersFormTitle">
                    ALTA DE USUARIO
                </IonCardTitle>
                <IonGrid className="ion-margin ion-no-margin-top">
                    <IonRow>
                        <IonCol className="ABMUsersFormCol" sizeLg='6' sizeXs='12'>
                            <IonLabel className="ion-margin-vertical ABMUsersFormLabel">
                                Nombre
                            </IonLabel>
                            <IonItem className="ABMUsersFormItem" lines='none'>
                                <IonInput
                                    type="text"
                                    placeholder="Nombre"
                                    className="ion-padding ABMUsersFormInput"
                                    name="first_name"
                                    autocomplete="new-password"
                                    value={first_name}
                                    onIonChange={(e) => {
                                        getDataForm(e)
                                    }}>
                                </IonInput>
                            </IonItem>
                            <IonText>
                                <p className={errors.first_name ? "login-valid-text" : "ion-hide"}>{errors.first_name}</p>
                            </IonText>
                        </IonCol>
                        <IonCol sizeLg='6' sizeXs='12' className="ABMUsersFormCol">
                            <IonLabel className="ion-margin-vertical ABMUsersFormLabel">
                                Apellido
                            </IonLabel>
                            <IonItem className="ABMUsersFormItem" lines='none'>
                                <IonInput
                                    type="text"
                                    placeholder="Apellido"
                                    className="ion-padding ABMUsersFormInput"
                                    id="input-id-add"
                                    name="last_name"
                                    autocomplete="new-password"
                                    value={last_name}
                                    onIonChange={(e) => {
                                        getDataForm(e)
                                    }}>
                                </IonInput>
                            </IonItem>
                            <IonText>
                                <p className={errors.last_name ? "login-valid-text" : "ion-hide"}>{errors.last_name}</p>
                            </IonText>
                        </IonCol>
                    </IonRow>

                    <IonRow>
                        <IonCol sizeLg='6' sizeXs='12' className="ABMUsersFormCol">
                            <IonLabel className="ion-margin-vertical ABMUsersFormLabel ABMUsersTooltipLabel">
                                Username
                                <IonIcon icon={helpCircleOutline} className="ABMUsersTooltip" />
                                <IonText className="ABMUsersTooltipText">No acepta mayúsculas</IonText>
                            </IonLabel>
                            <IonItem className="ABMUsersFormItem" lines='none'>
                                <IonInput
                                    type="text"
                                    placeholder="Username"
                                    className="ion-padding ABMUsersFormInput"
                                    id="input-id-add"
                                    name="username"
                                    autocomplete="new-password"
                                    value={username}
                                    onIonChange={(e) => {
                                        getDataForm(e)
                                    }}
                                    onKeyPress={(e) => onKeyPressLetters(e)} />
                            </IonItem>
                            <IonText>
                                <p className={errors.username ? "login-valid-text" : "ion-hide"}>{errors.username}</p>
                            </IonText>
                        </IonCol>
                        <IonCol className="ABMUsersFormCol" sizeLg='6' sizeXs='12'>
                            <IonLabel className="ion-margin-vertical ABMUsersFormLabel">
                                Cliente
                            </IonLabel>
                            <IonItem className="ABMUsersFormItem" lines='none'>
                                <IonInput
                                    type="text"
                                    placeholder="Selecciona un cliente"
                                    className="ion-padding ABMUsersFormInput"
                                    name="bank_id"
                                    value={props.client}
                                    disabled />
                            </IonItem>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol sizeLg='6' sizeXs='12' className="ABMUsersFormCol">
                            <IonLabel className="ion-margin-vertical ABMUsersFormLabel ABMUsersTooltipLabel">
                                Email
                                <IonIcon icon={helpCircleOutline} className="ABMUsersTooltip" />
                                <IonText className="ABMUsersTooltipText">No acepta mayúsculas</IonText>
                            </IonLabel>
                            <IonItem className="ABMUsersFormItem" lines='none'>
                                <IonInput
                                    type="text"
                                    placeholder="Email"
                                    className="ion-padding ABMUsersFormInput"
                                    id="input-id-add"
                                    name="email"
                                    autocomplete="new-password"
                                    value={email}
                                    onIonChange={(e) => getDataForm(e)}
                                    onKeyPress={(e) => onKeyPressLetters(e)} />
                            </IonItem>
                            <IonText>
                                <p className={errors.email ? "login-valid-text" : "ion-hide"}>{errors.email}</p>
                            </IonText>
                        </IonCol>
                        <IonCol className="ABMUsersFormCol" sizeLg='6' sizeXs='12'>
                            <IonLabel className="ion-margin-vertical ABMUsersFormLabel">
                                Reescriba el email
                            </IonLabel>
                            <IonItem className="ABMUsersFormItem" lines='none'>
                                <IonInput
                                    type="text"
                                    placeholder="Reescriba el email"
                                    className="ion-padding ABMUsersFormInput"
                                    name="emailRep"
                                    autocomplete="new-password"
                                    value={emailRep}
                                    onIonChange={(e) => getDataForm(e)} />
                            </IonItem>
                            <IonText>
                                <p className={errors.emailRep ? "login-valid-text" : "ion-hide"}>{errors.emailRep}</p>
                            </IonText>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol className="ABMUsersFormCol" sizeLg='6' sizeXs='12'>
                            <IonLabel className="ion-margin-vertical ABMUsersFormLabel">
                                Número De Teléfono
                            </IonLabel>
                            <IonItem className="ABMUsersFormItem" lines='none'>
                                <IonInput
                                    type="text"
                                    placeholder="+549XXXXXXXXXX"
                                    className="ion-padding ABMUsersFormInput"
                                    value={phone_number}
                                    name="phone_number"
                                    autocomplete="new-password"
                                    onIonChange={(e) => getDataForm(e)} />
                            </IonItem>
                            <IonText>
                                <p className={errors.phone_number ? "login-valid-text" : "ion-hide"}>{errors.phone_number}</p>
                            </IonText>
                        </IonCol>
                        <IonCol className="ABMUsersFormCol" sizeLg='6' sizeXs='12'>
                            <IonLabel className="ion-margin-vertical ABMUsersFormLabel">
                                Categoría
                            </IonLabel>
                            <IonItem className="ABMUsersFormItem" lines='none'>
                                {
                                    categoryClient === 'BANCOS' ?
                                    <IonInput
                                                    type="text"
                                                    placeholder="Selecciona una Categoría"
                                                    className="ion-padding ABMUsersFormInput"
                                                    name="bank_id_category"
                                                    value="NEWPAY"
                                                    disabled />
                                    :
                                        categoryClient === 'RETAIL' ?
                                        <IonInput
                                                    type="text"
                                                    placeholder="Selecciona una Categoría"
                                                    className="ion-padding ABMUsersFormInput"
                                                    name="bank_id_category"
                                                    value="PAYWAY"
                                                    disabled />
                                    :
                                            categoryClient === 'INTERNO' ?
                                            <IonInput
                                                    type="text"
                                                    placeholder="Selecciona una Categoría"
                                                    className="ion-padding ABMUsersFormInput"
                                                    name="bank_id_category"
                                                    value='PRISMA'
                                                    disabled />
                                    :
                                                <IonInput
                                                    type="text"
                                                    placeholder="Selecciona una Categoría"
                                                    className="ion-padding ABMUsersFormInput"
                                                    name="bank_id_category"
                                                    value={categoryClient}
                                                    disabled />
                                }
                            </IonItem>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol className="ABMUsersFormCol" sizeLg='6' sizeXs='12'>
                            <IonLabel className="ion-margin-vertical ABMUsersFormLabel">
                                Contraseña provisioria
                            </IonLabel>
                            <IonItem className="ABMUsersFormItem" lines='none'>
                                <IonInput
                                    type="password"
                                    placeholder="Mínimo 8 caracteres"
                                    className="ion-padding ABMUsersFormInput"
                                    name="password"
                                    autocomplete="new-password"
                                    value={password}
                                    onIonChange={(e) => getDataForm(e)} />
                            </IonItem>
                            <IonText>
                                <p className={errors.password ? "login-valid-text" : "ion-hide"}>{errors.password}</p>
                            </IonText>
                        </IonCol>
                        <IonCol className="ABMUsersFormCol" sizeLg='6' sizeXs='12'>
                            <IonLabel className="ion-margin-vertical ABMUsersFormLabel">
                                Confirmar Contraseña Provisioria
                            </IonLabel>
                            <IonItem className="ABMUsersFormItem" lines='none'>
                                <IonInput
                                    type="password"
                                    placeholder="Mínimo 8 caracteres"
                                    className="ion-padding ABMUsersFormInput"
                                    name='passwordRep'
                                    autocomplete="new-password"
                                    value={passwordRep}
                                    onIonChange={(e) => getDataForm(e)} />
                            </IonItem>
                            <IonText>
                                <p className={errors.passwordRep ? "login-valid-text" : "ion-hide"}>{errors.passwordRep}</p>
                            </IonText>
                        </IonCol>
                    </IonRow>
                    <IonRow className="ABMUsers-container-button  ion-margin-horizontal ion-margin-top ion-no-margin-bottom ion-justify-content-center">
                        <IonButton type="submit" fill="clear" onClick={createNewUser}>
                            <IonIcon icon={checkmarkCircleOutline} color="success" className="ion-padding ion-no-padding-bottom AMBUsersButton" />
                        </IonButton>
                        <IonButton fill="clear" onClick={props.backToTable}>
                            <IonIcon icon={closeCircleOutline} color="danger" className="ion-padding ion-no-padding-bottom AMBUsersButton" />
                        </IonButton>
                    </IonRow>
                </IonGrid>
            </IonCard>

            <Modal
                modalConfirmation={{
                    textConfirmation: textModal,
                    onDidDimissConfirmModal: dismissModal,
                    isOpenModalConfirm: showModal,
                    onClickConfirmModal: dismissModal,
                }}
            />
        </div>
    )
}

interface StateTypes {
    clientMaintenance: ClientMaintenanceDefaultStateI
}

const mapStateProps = (state: StateTypes) => {
    return {
        clientMaintenance: state.clientMaintenance
    }
}

interface dispatchTypes {
    getABMUsers: () => void;
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        getABMUsers: () => dispatch(GetABMUsers())
    };
}

export default connect(mapStateProps, mapDispatchToProps)(AddABMUsers);